<script setup lang="ts">
const emit = defineEmits<{
  (e: 'closeModal'): void;
}>();
</script>

<template>
  <p>
    {{ $t('ajustes.plantillasUI.modalDialogTemplate.ten_en_cuenta') }}
  </p>
  <CButton class="w-100 fs-6 p-2" background="background-blue" @click="emit('closeModal');">
    <template #content>
      <div>
        <span>{{$t('global.confirmar')}}</span>
      </div>
    </template>
  </CButton>
</template>
